<div class="vouchers-container">
    <!-- Sticky Controls Container -->
    <div class="sticky-controls-container">
        <!-- Compact Header Section -->
        <div class="vouchers-header">
            <div class="header-row">
                <button class="back-button" (click)="goBack()" aria-label="Go back">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                    </svg>
                    <span>Back</span>
                </button>

                <div class="customer-info">
                    <div class="customer-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                    </div>
                    <div class="customer-details">
                        <h1 class="customer-name">{{ customerName }}</h1>
                        <p class="customer-label">Customer Vouchers</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bill Amount Input Section -->
        <div class="bill-section">
            <div class="bill-input-wrapper">
                <label for="billAmount" class="bill-label">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z" />
                    </svg>
                    Total Bill Amount
                </label>
                <div class="input-group">
                    <span class="currency-prefix">₹</span>
                    <input type="number" id="billAmount" [(ngModel)]="billAmount" (ngModelChange)="onBillAmountChange()"
                        placeholder="Enter bill amount" class="bill-input" min="0" autocomplete="off" />
                </div>
            </div>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-section" *ngIf="isLoading">
        <div class="loading-spinner"></div>
        <p class="loading-text">Loading vouchers...</p>
    </div>

    <!-- Error Message -->
    <div class="error-message" *ngIf="errorMessage && !isLoading">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>{{ errorMessage }}</span>
    </div>

    <!-- Vouchers List -->
    <div class="vouchers-content" *ngIf="!isLoading && !errorMessage">
        <!-- When vouchers exist -->
        <div class="vouchers-list" *ngIf="vouchers.length > 0">
            <div class="voucher-card" *ngFor="let voucher of vouchers" [class.disabled]="!isClaimable(voucher)"
                [class.selected]="isVoucherSelected(voucher.id!)" (click)="toggleVoucherSelection(voucher)">

                <div class="voucher-header-row">
                    <!-- Checkbox for Multi-Select -->
                    <div class="voucher-checkbox-wrapper" *ngIf="isClaimable(voucher)"
                        (click)="$event.stopPropagation()">
                        <input type="checkbox" [checked]="isVoucherSelected(voucher.id!)"
                            [disabled]="!canSelectVoucher(voucher)" (change)="toggleVoucherSelection(voucher)"
                            class="voucher-checkbox" />
                    </div>

                    <div class="voucher-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
                        </svg>
                    </div>
                    <span class="voucher-status" [ngClass]="getStatusClass(voucher)">
                        {{ getStatusLabel(voucher.status) }}
                    </span>
                </div>

                <div class="voucher-body">
                    <h3 class="voucher-title">{{ voucher.voucherConfigName || 'Voucher' }}</h3>

                    <div class="voucher-amount" *ngIf="voucher.voucherAmount">
                        <span class="amount-label">Voucher Value:</span>
                        <span class="amount-value">₹{{ voucher.voucherAmount | number:'1.2-2' }}</span>
                    </div>

                    <div class="voucher-details">
                        <div class="detail-item">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                            </svg>
                            <span class="detail-label">Code:</span>
                            <span class="detail-value voucher-code">{{ voucher.voucherCode }}</span>
                        </div>

                        <div class="detail-item" *ngIf="voucher.minimumPurchaseAmount">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                            <span class="detail-label">Min. Purchase:</span>
                            <span class="detail-value">₹{{ voucher.minimumPurchaseAmount | number:'1.2-2' }}</span>
                        </div>

                        <div class="detail-item">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <span class="detail-label">Expires:</span>
                            <span class="detail-value">{{ formatDate(voucher.expiryDate) }}</span>
                        </div>
                    </div>

                    <!-- Eligibility Warning -->
                    <div class="eligibility-warning"
                        *ngIf="billAmount !== null && voucher.minimumPurchaseAmount && voucher.minimumPurchaseAmount > billAmount">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        <span>Bill amount needs to be ₹{{ voucher.minimumPurchaseAmount | number:'1.2-2' }}</span>
                    </div>





                    <!-- Redeemed Info -->
                    <div class="redeemed-info" *ngIf="voucher.status === VoucherStatus.Redeemed && voucher.redeemedAt">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span>Redeemed on {{ voucher.redeemedAt | date:'dd MMM yyyy, hh:mm a' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State - No Vouchers -->
        <div class="empty-state" *ngIf="vouchers.length === 0">
            <div class="empty-state-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
                </svg>
            </div>
            <h3 class="empty-state-title">No Vouchers Found</h3>
            <p class="empty-state-text">This customer doesn't have any vouchers yet</p>
            <button class="btn-back-to-search" (click)="goBack()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Search Another Customer
            </button>
        </div>
    </div>

    <!-- Bulk Claim Sticky Footer -->
    <div class="bulk-claim-footer" *ngIf="selectedVoucherIds.size > 0" [@slideDown]>
        <!-- Bulk OTP Section -->
        <div class="bulk-otp-section" *ngIf="showBulkOtpSection">
            <div class="otp-section-header">
                <h4 class="bulk-otp-title">Verify Bulk Claim</h4>
                <button class="close-btn" (click)="closeBulkOtpSection()" [disabled]="bulkClaimData.isProcessing">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <!-- Bulk OTP Body -->
            <div class="otp-section-body">
                <!-- Error/Success Messages -->
                <div class="alert alert-error" *ngIf="bulkClaimData.errorMessage">{{ bulkClaimData.errorMessage }}</div>
                <div class="alert alert-success" *ngIf="bulkClaimData.successMessage">{{ bulkClaimData.successMessage }}
                </div>

                <!-- Info Message -->
                <div class="otp-info" *ngIf="!bulkClaimData.otpVerified">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    An OTP will be sent to the customer's phone number for verification
                </div>

                <!-- OTP Verification Component -->
                <app-otp-verification *ngIf="!bulkClaimData.otpVerified"
                    [phoneNumber]="getUserSelectedVouchers()[0]?.customerPhoneNumber || ''" [autoSend]="true"
                    (verified)="onOtpVerified()" (error)="onOtpError($event)">
                </app-otp-verification>

                <!-- Additional Fields (shown after OTP verification) -->
                <div *ngIf="bulkClaimData.otpVerified" class="additional-fields" [@slideDown]>
                    <!-- Redemption Reference Input -->
                    <div class="form-group">
                        <label for="bulk-redemption-ref" class="form-label">
                            Transaction Reference <span class="required">*</span>
                        </label>
                        <input type="text" id="bulk-redemption-ref" class="form-input"
                            [(ngModel)]="bulkClaimData.redemptionReference" placeholder="e.g., Invoice #, Bill #"
                            [disabled]="bulkClaimData.isProcessing" autocomplete="off" required />
                    </div>

                    <!-- Notes Input -->
                    <div class="form-group">
                        <label for="bulk-notes" class="form-label">
                            Notes (Optional)
                        </label>
                        <textarea id="bulk-notes" class="form-textarea" [(ngModel)]="bulkClaimData.notes"
                            placeholder="Add any additional notes..." rows="2" [disabled]="bulkClaimData.isProcessing"
                            autocomplete="off"></textarea>
                    </div>

                    <!-- Claim Button -->
                    <button class="btn-claim-vouchers" (click)="onBulkClaimSuccess()"
                        [disabled]="bulkClaimData.isProcessing || !isRedemptionReferenceValid()">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                            *ngIf="!bulkClaimData.isProcessing">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div class="spinner-small" *ngIf="bulkClaimData.isProcessing"></div>
                        <span>{{ bulkClaimData.isProcessing ? 'Claiming Vouchers...' : 'Claim Vouchers' }}</span>
                    </button>

                    <!-- Processing Message -->
                    <div class="processing-message" *ngIf="bulkClaimData.isProcessing">
                        <div class="spinner-small"></div>
                        <span>Processing your claim...</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Summary Bar -->
        <div class="bulk-summary-bar" *ngIf="!showBulkOtpSection">
            <div class="summary-info">
                <span class="count-badge">{{ selectedVoucherIds.size }} vouchers</span>
                <div class="value-info">
                    <span class="total-label">Total Value:</span>
                    <span class="total-amount">₹{{ getTotalSelectedValue() | number:'1.2-2' }}</span>
                </div>
                <div class="requirement-info">
                    <span class="req-label">Min Purchase:</span>
                    <span class="req-value" [class.error]="!isBulkClaimEligible()">
                        ₹{{ getTotalMinPurchaseRequired() | number:'1.2-2' }}
                    </span>
                </div>
                <div class="balance-info" *ngIf="billAmount !== null && billAmount !== undefined">
                    <span class="balance-label">Balance to Pay:</span>
                    <span class="balance-amount">₹{{ getBalanceToPay() | number:'1.2-2' }}</span>
                </div>
            </div>

            <button class="btn-bulk-claim" [disabled]="!isBulkClaimEligible()" (click)="initiateBulkClaim()">
                Claim Selected
            </button>
        </div>
    </div>
</div>